import { render } from "./PlayoutListItemV2.vue?vue&type=template&id=1b422e60&scoped=true"
import script from "./PlayoutListItemV2.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutListItemV2.vue?vue&type=script&setup=true&lang=js"

import "./PlayoutListItemV2.vue?vue&type=style&index=0&id=1b422e60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b422e60"],['__file',"src/components/TVPlayout/PlayoutListItemV2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1b422e60"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1b422e60', __exports__)) {
    api.reload('1b422e60', __exports__)
  }
  
  module.hot.accept("./PlayoutListItemV2.vue?vue&type=template&id=1b422e60&scoped=true", () => {
    api.rerender('1b422e60', render)
  })

}


export default __exports__